<template>
  <el-dialog :visible.sync="visible" width="500px" title="管理员" @close="handleClose" append-to-body>
    <div v-if="admins.length">
      <div v-for="(admin, idx) in admins" :key="idx" class="admin-item">
        <el-avatar :src="admin.avatar" size="large" />
        <span class="admin-info">{{ admin.name }}({{ admin.role }})</span>
      </div>
    </div>
    <div v-else class="empty">暂无管理员</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'adminisVue',
  data() {
    return {
      visible: false,
      admins: []
    }
  },
  methods: {
    // 外部调用此方法弹出弹窗
    handleShow(adminList = []) {
      // 这里可以传递管理员列表，或自行请求接口
      this.admins = adminList.length
        ? adminList
        : [
          // 示例数据
          {
            avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
            name: '阳光大男孩',
            role: '技术老师'
          },
          {
            avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
            name: '阳光大男孩',
            role: '技术老师'
          },
          // ...可添加更多
        ]
      this.visible = true
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.admin-item {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.admin-info {
  margin-left: 16px;
  font-size: 16px;
  color: #333;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>
